export default {
  //全局使用
  global: {
    modalTitle: '提示',
    loginInvalid: '当前登录失效，请重新登录。',
  },
  errorTips: {
    paramsErr: '参数不符合校验,请重新填写提交。',
  },
  //首页相关
  //enter.js
  welcome: {
    title: 'MEET HIVE',
    enter: '点击进入',
    brand: '蜂巢智慧',
    slogan: '让城市生活更美好',
  },

  //welcomeHeader.js
  official: {
    website: 'MEETHIVE官网',
    product: '核心科技',
    about: '关于HI环卫',
  },

  //登录注册相关
  //welcome.js
  login: {
    detail: {
      account: '账号',
      password: '密码',
      inputPhoneNumber: '请输入正确的手机号',
      wrongFormat: '账号格式有误',
      rules: '最少6位密码',
      inconsistent: '两次密码输入不一致',
      phone: '手机号',
      inputPhone: '请输入手机号',
      setAccount: '设置账号',
      startRule: '请以字母开头',
      repeatAccount: '用户名重复',
      setPassword: '设置密码',
      passwordRules: '密码不少于六位',
      confirmPass: '确认密码',
      pleaseConfirm: '请确认密码',
    },
    title: 'HI蜂巢',
    slogan: '让城市生活更美好',
    checked: '记住密码',
    logIn: '登录',
    forget: '忘记密码?',
    register: '注册账号',
    contract: {
      complete: '完成注册',
      agree: '我已阅读并同意',
      content: '《蜂巢服务条款》',
      serviceContent:
        '特别提示：<br/>\n' +
        '                                    以下条款是您与东莞蜂巢智慧智能科技有限公司（以下简称“蜂巢智慧”）于东莞市松山湖管委会（以下简称“本协议签订地”）所订立的具备法律效力的协议。本协议确立您使用HI环卫软件系统时享有的权利以及相应的法律责任，HI环卫软件系统指由东莞蜂巢智慧智能科技有限公司开发并作为本协议项下的软件系统，包括且不限于电脑端网站、移动端应用软件及在第三方网络平台上的公众号和小程序。在本协议中，“您”指任何使用和访问本服务的个人。<br/>\n' +
        '                                    请您务必仔细阅读、充分理解本协议中各条款，包括免除或者限制蜂巢智慧责任的免责条款及对用户的权利限制条款，点击同意表明您已经阅读并接受这些条款。如果您不接受本协议的所有条款，请您停止注册、登录或使用本服务。您的注册、登录、使用等行为将视为您同意接受本协议的约束。<br/>\n' +
        '                                    蜂巢智慧可能会根据需要不时修订或更新本协议及其相关补充和附件等文件，修订或更新后的协议和文件一经公布，立刻取代原协议和文件，即自动生效。如果您不接受相关的修订或更新，请立即停止使用HI环卫服务或与蜂巢智慧联系；如您继续使用HI环卫服务，即表示您已接受修订或更新后的协议和文件。<br/>\n' +
        '\n' +
        '                                    1. 用户注册<br/>\n' +
        '                                    1.1 用户应当向蜂巢智慧购买相关服务，获得蜂巢智慧许可后，进行HI环卫的注册工作，否则蜂巢智慧无法为客户提供HI环卫的各类服务。<br/>\n' +
        '                                    1.2 用户确认：HI环卫的注册用户包括政府机构、事业单位、企业以及政府机构、事业单位和企业的工作人员。用户分为Ⅰ、Ⅱ、Ⅲ三级：Ⅰ级用户为政府机构、事业单位、企业，由蜂巢智慧进行账号分配；Ⅱ级用户为政府机构、事业单位和企业的管理人员，由管理人员隶属的单位进行账号分配；Ⅲ级用户为环卫工人，由环卫工人的上级进行账号分配。<br/>\n' +
        '                                    1.3 注册方式：各级用户通过手机号进行绑定注册。Ⅱ、Ⅲ级用户在注册前，应当获得上级用户发送的邀请链接，点击邀请链接进行注册。Ⅰ级用户账号由蜂巢智慧进行分配，分配后直接进行登录。<br/>\n' +
        '                                    1.4 账号管理：用户注册成功后，每个用户获得专属账号，禁止赠予、借用、租用、转让或售卖。用户承担其账号与密码的保管责任，除平台方（如微信）或蜂巢智慧的过错外，用户就其账号及密码项下一切活动负全部责任。<br/>\n' +
        '\n' +
        '                                    2. 服务范围与使用规范<br/>\n' +
        '                                    2.1 Ⅰ级用户可以在电脑端查看其管辖区域内所有果皮箱、垃圾桶的溢满状况，分配管理所属工作人员的Ⅱ、Ⅲ级用户账号和果皮箱、垃圾桶，查看管辖区域内工作人员数据与果皮箱、垃圾桶数据；Ⅱ级用户可以在电脑端查看其管辖区域内所有果皮箱、垃圾桶的溢满状况，分配管理所属工作人员的Ⅲ级用户账号和果皮箱、垃圾桶，查看管辖区域内工作人员数据与果皮箱、垃圾桶数据；Ⅰ、Ⅱ、Ⅲ三级用户均可以在移动端及小程序查看其管辖区域内所有果皮箱、垃圾桶的溢满状况与最优路径。<br/>\n' +
        '                                    2.2 用户在使用HI环卫服务过程中，应当遵循以下规则：<br/>\n' +
        '                                    1）遵守中华人民共和国法律法规和政府规定；<br/>\n' +
        '                                    2）不得利用HI环卫软件系统进行任何可能对互联网造成不利影响的行为；<br/>\n' +
        '                                    3）不得侵犯任何第三方的专利权、著作权、商标权、名誉权、隐私权、个人信息或其他任何合法权益。<br/>\n' +
        '                                    2.3 蜂巢智慧有权在HI环卫系统上进行各类推广以及广告投放业务。<br/>\n' +
        '\n' +
        '                                    3. 传感器的安装与管理<br/>\n' +
        '                                    3.1 蜂巢智慧拥有品牌标记为“HI-Tech”的传感器的专利所有权，负责传感器的安装与维护。在传感器安装交付给客户前，传感器的所有权归属于蜂巢智慧；交付后，传感器的所有权归属于客户单位。<br/>\n' +
        '                                    3.2 未经蜂巢智慧同意，任何人不得破坏或移除所有权归属蜂巢智慧的传感器，蜂巢智慧有权向其索赔；如破坏或移除所有权归属他人的已经安装的传感器，蜂巢智慧亦有权代所有者向其索赔。<br/>\n' +
        '                                    3.3 任何人不得在传感器上张贴广告、涂抹，不得对传感器泼水、加热。<br/>\n' +
        '\n' +
        '                                    4. 知识产权声明<br/>\n' +
        '                                    4.1 HI环卫的一切著作权、商标权、专利权、商业秘密、数据等知识产权，以及相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。除涉及第三方授权的软件或技术外，蜂巢智慧享有HI环卫及其中所有内容的知识产权。<br/>\n' +
        '                                    4.2 用户不得对软件或者软件运行过程中释放到任何计算机终端内存中的数据及软件运行过程中，客户端与服务器端的交互数据进行下载、复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于插件、外挂或非经授权的第三方工具/服务。<br/>\n' +
        '\n' +
        '                                    5. 用户数据及隐私政策<br/>\n' +
        '                                    5.1 用户向蜂巢智慧提供的所有注册资料应当是真实、完整、准确、合法、有效的。如果用户提供的注册资料有所变更，用户应当及时更新，蜂巢智慧将依法对用户信息进行检查核实，用户应当配合提供最及时、真实、完整的信息。<br/>\n' +
        '                                    5.2 蜂巢智慧依法保护用户隐私，保证不对外公开或向第三方提供单个用户的注册资料及用户在使用服务时存储在HI环卫服务系统中受法律保护的隐私信息，以下情况除外：<br/>\n' +
        '                                    1）事先获得用户的明确同意；<br/>\n' +
        '                                    2）根据有关的法律法规要求；<br/>\n' +
        '                                    3）按照相关政府主管部门的要求；<br/>\n' +
        '                                    4）根据法院的生效判决、裁定或命令；<br/>\n' +
        '                                    5）为维护蜂巢智慧的合法权益或社会公共利益而在相关行政程序或司法程序中向政府主管部门或法院提供。<br/>\n' +
        '\n' +
        '                                    6. 免责声明<br/>\n' +
        '                                    6.1 蜂巢智慧对服务不作任何类型的担保，包括但不限于服务的及时性、安全性、准确性，对在任何情况下由可归于用户自身的原因导致的直接、间接、偶然、特殊及后续的损害及风险，蜂巢智慧不承担责任。<br/>\n' +
        '                                    6.2 对于不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何网络、技术、通信线路等原因造成的服务中断或不能满足用户需求的风险，用户理解并同意，蜂巢智慧对该等风险没有过错，蜂巢智慧不对此承担责任。<br/>\n' +
        '                                    6.3 用户充分理解并认可本协议各项约定，并同意蜂巢智慧免于承担因用户违反约定而产生的活与之有关的任何索赔、处罚、责任、费用或损失（包括但不限于第三方索赔），除非本协议另有约定或有证据证明蜂巢智慧对此具有重大过错。<br/>\n' +
        '\n' +
        '                                    7. 违约责任<br/>\n' +
        '                                    7.1 如因蜂巢智慧违反有关法律法规或本协议项下的任何条款，而给用户造成实际损失，蜂巢智慧同意承担由此造成的违约责任。<br/>\n' +
        '                                    7.2 用户同意保障和维护蜂巢智慧及其他用户的合法权益，如因用户违反有关法律法规或本协议项下的任何条款，而给蜂巢智慧或任何第三方造成损失，用户同意承担由此造成的违约责任，包括但不限于赔偿蜂巢智慧并使蜂巢智慧免于因此遭受所有直接和间接损失（包括任何直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等）。<br/>\n' +
        '\n' +
        '                                    8. 协议变更及终止<br/>\n' +
        '                                    8.1 鉴于互联网服务市场及相关领域的快速发展及变化，用户理解并同意，蜂巢智慧有权随时修改本协议的任何条款，一旦本协议的内容发生变动，蜂巢智慧会直接在HI环卫软件系统上公布修改后的协议内容（形式包括但不限于更新版本的协议、补充协议、协议新增附件等）。该公布行为视为蜂巢智慧已经通知用户修改内容，同时蜂巢智慧也可以通过其他适当方式向用户提示修改内容。<br/>\n' +
        '                                    8.2 用户不得单方终止本协议，如需终止本协议，应当联系蜂巢智慧进行友好的协商进行终止。<br/>\n' +
        '                                    8.3 蜂巢智慧在出现以下任何情况是，蜂巢智慧有权单方终止本协议：<br/>\n' +
        '                                    1）用户严重违反本协议约定，或多次违反本协议约定；<br/>\n' +
        '                                    2）用户行为存在异常，我们合理怀疑用户可能存在违法或违反本协议约定的行为，如果不终止本协议可能对蜂巢智慧、其他用户、公共秩序或公共利益造成不利影响；<br/>\n' +
        '                                    3）用户存在盗用他人账号、发布违禁信息、骗取他人财物、采取不正当手段牟利等行为；<br/>\n' +
        '                                    4）其他应当终止本协议的情况。<br/>\n' +
        '                                    8.4 本协议终止后，除法律另有明确规定外，蜂巢智慧无义务向用户或任何指定的第三方披露该用户账号中的任何信息。本协议终止后，蜂巢智慧仍享有以下权利：<br/>\n' +
        '                                    1）继续保存留存于HI环卫软件系统中的各类信息；<br/>\n' +
        '                                    2）对于用户过往的违约行为，我们仍可依据本协议追究其违约责任。<br/>\n' +
        '\n' +
        '                                    9. 适用法律与争议解决<br/>\n' +
        '                                    9.1 本协议的订立、履行和解释及与之相关的争议的解决均应适用中华人民共和国法律。<br/>\n' +
        '                                    9.2 如您与蜂巢智慧就本协议及其所有补充和附件的签署、内容、解释或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，对于因本协议及其所有补充和附件而产生的或与之有关的一切争议，您同意将其提交本协议签订地有管辖权的人民法院管辖。<br/>\n' +
        '\n' +
        '                                    10. 其他规定<br/>\n' +
        '                                    10.1 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，不影响本协议其他条款的效力。在此情形下，各方应当在合法范围内协商确定新的条款，以保证最大限度地实现原有条款的意图。<br/>\n' +
        '                                    10.2 本协议中的标题为方便理解而设，在解释本协议时不受该标题的限制。<br/>\n' +
        '                                    10.3 任何一方当事人放弃或延迟行使其在本协议项下的全部或部分权利的，不应视为其放弃本协议项下的任何其他权利或与此类似的一切权利。<br/>',
    },
    registerSure: '确认',
    hadOrReturn: '已有账号?返回登录',
  },

  //用户相关
  //userListItem.jsx
  userListInfo: {
    distribute: '分配箱子',
    edit: '编辑',
    del: '删除',
    info: '基本信息',
    safe: '安全',
    weChat: '微信',
    account: '账号',
    unKnow: '未知',
    shield: '屏蔽',
    shieldInfo:
      '屏蔽后该微信号将无法正常登陆HI环卫,但通过解除屏蔽可正常登陆，确认执行此操作吗？',
    unblock: '解除屏蔽',
    unblockInfo: '解除屏蔽后该微信号可正常登陆HI环卫,确认执行此操作吗？',
    MessageReminder: '消息提醒',
    open: '开',
    close: '关',
    phone: '手机',
    phoneNum: '手机号',
    unset: '未设置',
    email: '邮箱',
    emailNum: '邮箱号',
    okText: '确定',
    cancelTxt: '取消',
    workbenchReminder: '工作台溢满提醒',
    workbenchReminderTips:
      '位于工作台右侧的箱体详情列表里，长期未清理的箱体可设置强提醒。',
    highlight: '置顶显示',
    musicTips: '声音',
    untie: '解绑',
    untieTips: '解绑后该微信号将无法登陆到HI环卫,确认执行此操作吗？',
    untiePhone: '解绑后该手机号将无法登陆到HI环卫,确认执行此操作吗？',
    untieEmail: '解绑后该邮箱号将无法登陆到HI环卫,确认执行此操作吗？',
  },
  //userList.jsx
  userList: {
    icon: '+ ',
    create: '创建',
    total: '共',
    area: '个区域',
  },

  //创建团队相关
  //CreateGroup.js
  createTeam: {
    teamManage: '团队管理',
    teamTip: '注意',
    tipDetail: '您目前还没有团队，快来创建团队吧~',
    createATeam: '创建',
    group: {
      name: '团队名称',
      inputName: '请输入团队名称!',
      rules: '(中文、字母、数字、下划线)',
      digital: '6位以上',
      demands: '可填写公司名或其他具代表性名称',
    },
    email: {
      mailBox: '邮箱',
      inputAddress: '请输入邮箱!',
      wrongFormat: '格式错误',
      demands: '请输入您的邮箱号',
    },
    groupAdd: {
      address: '团队地址',
      inputAddress: '请输入团队地址!',
      rules: '(中文、字母、数字、下划线)',
      digital: '3位以上',
      demands: '您的团队地址(例：山东省菏泽市)',
      create: '创建',
    },
    info: {
      tip: '注意',
      congratulate:
        '恭喜您创建成功！之后可在 我的账户\n' +
        '                  面板对刚填写的信息进行再次修改。',
      got: '好的，我知道了',
      create: '创建',
    },
    createMyAccount: '创建我的账户',
    completeness: '完整度',
  },

  //员工首页信息相关
  staffHomeInfo: {
    working: '工作中',
    prepareToWork: '准备工作中',
    prepareToClean: '准备清运中',
    name: '姓名',
    phone: '电话',
    region: '区域',
    member: '环卫员工',
    workplace: '工作区域',
    clearSpeed: '清运速度',
    unit: '小时/桶',
    currState: '当前状态',
    workplaceState: '工作区域状态',
    halfMonthNotClear: '半月未清',
    // workingState: '工作中',
    // prepareWork: '准备工作中',
    overflow: '溢满',
    halfFull: '半满',
    empty: '量少',
    single: '个',
    dailyClear: '今日已清运',
    dailyClear2: '今日已清运',
    hour: '小时',
    kilos: '千克',
    clearTotalTime: '清运时间统计',
    forecastInfo:
      '此趋势图表示近七天内此环卫工人每天清运所花费的实际时间。所用时间较多，环卫工人在户外工作的劳动风险高；所用时间较少，环卫工人的劳动价值体现少；管理者可以将环卫工人实际清运时间控制在一定范围内，如果需要本系统在此方面也可以给出一些建议。',
    forecastInfoDes: {
      main: '近七天内此环卫工人出行清运的时刻主要分布在',
      time: '点和',
      timeClock: '点',
      average: '；平均每天花费',
      hour: '小时',
      action: '进行清运。',
    },
    forecastInfoDes2: {
      clearTotal: '清运总量统计',
      forecastInfo:
        '此趋势图表示近七天内此环卫工人每天清运垃圾的总量。每天清运垃圾的总量主要取决于此区域每天垃圾的产生总量；管理者可以尽可能使每一个环卫工人工作区域的清运量相等，如果需要本系统在此方面也可以给出一些建议。',
      unit: '(kg)',
      forecast: {
        main: '近七天内此环卫工人工作区域的垃圾主要分布在',
        time: '点和',
        timeClock: '点',
        timeDetail: '这两个时刻产生；',
        average: '平均每天环卫工人要清运',
        unit: '千克',
        rush: '垃圾。',
      },
    },
    return: '返回到地图',
    cleanTime: '清运时长',
    cleanAmount: '清运总量',
  },

  //navigator.js
  // 管理界面
  manage: {
    home: '首页',
    areaManage: '区域管理',
    areaDivision: '区域划分',
    dataCount: '数据统计',
    staffDataCount: '区域动态',
    dataAnalysis: '大数据分析平台',
    dataDetail: '数据明细',
    dynamicData: '动态数据图',
    equipmentManage: '设备管理',
    equipmentWithError: '故障设备',
    equipmentSpec: '规格管理',
    equipmentPower: '电量管理',
    accountManage: '账号管理',
    myAccount: '我的账户',
    helpCenter: '帮助中心',
    commonQuestions: '常见问题',
    support: '支持',
    exitAccount: '退出账户',
    shrinkTab: '缩小面板',
    serviceAccount: '服务账户',
  },

  manageTop: {
    exit: '退出',
  },

  //溢满时间
  time: {
    day: '日',
    week: '周',
    month: '月',
  },

  //tips相关
  tipsInfo: {
    littleTip: '提示',
    chooseContent: '车库仓库均确定后，点击左侧“应用“完成设置！',
    forSure: '确定',
    cancel: '取消',
  },

  //overview.js
  toolbar: {
    leftFloatWindow: {
      header: '负责人',
      existQuantity: '已有量',
      allNoticed: '已通知',
    },
    floatWindowDetail: {
      acknowledged: '我知道了',
      trend: '趋势',
      trendDes:
        '此趋势图表示某时间段内该垃圾桶桶内的已有量，通过分析此图可以掌握该垃圾桶清运时间的规律，以此进行清运规划，提高效率，节约人力。',
      trendGraph: {
        day: '日',
        week: '周',
        month: '月',
        noData: '本月无数据',
        dataDes: '已有量',
      },
    },
    pieChartDes: {
      remainCapacity: '剩余容量',
      occupiedCapacity: '已占容量',
    },
    lineChart: {
      title: '已有量',
    },
    tipInfo: {
      tryScroll: '鼠标滚动试试，时间线条会',
      moreDetailed: '变的更详细哦~',
      acknowledge: '我知道了',
    },
    trendDes: {
      trend: '趋势',
      trendInfo:
        '此趋势图表示某时间段内该垃圾桶桶内的已有量，通过分析此图可以掌握该垃圾桶清运时间的规律，以此进行清运规划，提高效率，节约人力。',
      trendIcon: 'i',
      day: '日',
      week: '周',
      month: '月',
      detail: '详情',
      existingQuantity: '已有量',
    },
    home: '首页',
    staffManage: '人员管理',
    createATeam: '创建团队',
    controlArea: '区域管理',
    data: '数据统计',
    deviceManagement: '设备管理',
    accountManage: '账户管理',
    helpCenter: '帮助中心',
    myAccount: '我的账户',
    logout: '退出登录',
    unfoldTab: ' 展开面板',
    rightFloatWindow: {
      switch: '点击可以收起/展开侧面面板',
      haveKnown: '我知道了',
      allAcknowledge: '点击“全部已通知”可处理全部长期未处理箱子',
      placeholder: '请输入桶的ID或者名称',
      allList: '全部',
      showAll: '显示全部',
      showRed: '显示红色',
      showOrange: '显示橘色',
      showGreen: '显示绿色',
      existQuantity: '已有量',
      showID: '显示ID',
      showName:'显示名称',
      allNoticed: '全部已通知',
      todayNeedCollect: '今日需收',
      canQuantity: '个',
      hideEmpty: '隐藏空桶',
      showEmpty: '显示空桶',
    },
    edit: '点击编辑',
    number: 'No.',
    exit: '登出',
    none: '无',
  },

  //management.js
  areaManagement: {
    title: '区域划分',
    districtAdministrator: '大区',
    staff: '下属工作区',
    typeList: '大区列表',
    subWorkArea: '下属工作区',
    tip: '注意',
    confirmDelete: '请确定是否执行”删除“操作',
    deleteForSure: '确认删除',
    hasSubordinateUser:
      '当前大区存在下属工作区，请删除下属工作区后再删除当前大区。',
    deleteErr: '删除失败',
    cancel: '取消',
    searchYouWant: '在这输入想找的对象...',
  },

  /*areaManagement: {
    title: "区域管理",
    superAdmin: "超级管理员",
    count: "个",
    districtAdministrator: "大区管理员",
    staff: "环卫员工",
    typeList: "大区列表",
    subWorkArea: "下属工作区",
    tip: "提示",
    confirmDelete: "请确定是否执行”删除“操作",
    deleteForSure: "确认",
    cancel: "取消",
    searchYouWant: "在这输入想找的对象...",
  },

  //management.js
  //注册大区相关(旧版)
  /* areaManagement: {
    inviteLink: "<邀请链接七天内有效>",
    areaName: "大区名称",
    phoneNumber: "手机号",
    inputNumber: "请输入数字",
    inputRangedNumber: "请输入11-9999范围内的数字",
    inputNonNegative: "请输入大于等于0的数字",
    wrongFormat: {
      account: "账号格式错误",
      password: "密码格式错误",
      inconsistent: "密码不一致",
      managerNameIsRequired: "管理员名称不能为空",
      correctPhoneNumber: "请输入正确的手机号码",
      wrongFormatNumber: "格式不正确",
      inputPositive: "请输入大于等于0的数字",
      nameIsRequired: "名称不能为空",
      workAreaAccount: "工作区账号格式不正确",
      staffNameIsRequires: "清运者名称不能为空",
      correctTelNumber: "请输入正确的电话号码",
    },
    title: "区域管理",
    superAdmin: "超级管理员",
    count: "个",
    districtAdministrator: "大区管理员",
    staff: "环卫员工",
    subWorkArea: "下属工作区",
    createDistrict: "创建大区",
    completion: "完整度",
    create: "创建",
    account: "<span>大</span>\n" +
    "                  <span>区</span>\n" +
    "                  <span>账</span>\n" +
    "                  <span>号</span>",
    password: "<span>密</span>\n" +
    "                  <span>码</span>",
    inputDemands: "请输入账号(6-15位字母或数字，字母在前)",
    repeatUsername: "用户名重复",
    typeList: "大区列表",
    inputPasswordDemands: "请输入密码(6-15位)",
    confirmPassword: "<span>确</span>\n" +
    "                  <span>认</span>\n" +
    "                  <span>密</span>\n" +
    "                  <span>码</span>",
    confirmAgain: "请再次输入密码",
    districtName: "<span>大</span>\n" +
    "                  <span>区</span>\n" +
    "                  <span>名</span>\n" +
    "                  <span>称</span>",
    inputDistrictName: "请输入大区名称",
    managerName: "<span>管</span>\n" +
    "                  <span>理</span>\n" +
    "                  <span>员</span>\n" +
    "                  <span>姓</span>\n" +
    "                  <span>名</span>",
    manager: "管理员",
    inputManagerName: "请输入管理员名称",
    contact: "<span>联</span>\n" +
    "                  <span>系</span>\n" +
    "                  <span>电</span>\n" +
    "                  <span>话</span>",
    inputTel: "请输入手机号码",
    staffCount: "<span>员</span>\n" +
    "                  <span>工</span>\n" +
    "                  <span>数</span>\n" +
    "                  <span>量</span>",
    inputStaffCount: "请输入员工数量",
    totalStaffCount: "员工数量",
    carsCount: "<span>车</span>\n" +
    "                  <span>辆</span>\n" +
    "                  <span>数</span>\n" +
    "                  <span>量</span>",
    inputCarsCount: "请输入车辆数量",
    totalCarsCount: "车辆数量",
    danwei: "(车)",
    cancel: "取消",
    createsubWorkArea: "创建下属工作区账户",
    workplaceAccount: "<span>工</span>\n" +
    "                  <span>作</span>\n" +
    "                  <span>区</span>\n" +
    "                  <span>账</span>\n" +
    "                  <span>号</span>",
    workplaceName: "<span>工</span>\n" +
    "                  <span>作</span>\n" +
    "                  <span>区</span>\n" +
    "                  <span>名</span>\n" +
    "                  <span>称</span>",
    inputAccountDemands: "请输入账号(字母或数字，字母在前)",
    repeatAccount: "账号重复",
    inputPassword: "请输入密码",
    workAreaName: "工作区名称",
    inputWorkplaceName: "请输入工作区名称",
    staffName: "<span>清</span>\n" +
    "                  <span>运</span>\n" +
    "                  <span>者</span>\n" +
    "                  <span>名</span>\n" +
    "                  <span>称</span>",
    inputStaffName: "请输入清运者名称",
    fulledCarWeight: "<span>满</span>\n" +
    "                  <span>车</span>\n" +
    "                  <span>重</span>\n" +
    "                  <span>量</span>",
    fullCarWeight: "满车重量",
    inputKilos: "请输入公斤数",
    inputFullCarWeightKilos: "请输入满车重量公斤数",
    danwei2: "(kg)",
    edit: "编辑",
    workplaceAcc: "工作区账号",
    districtBelongTo: "所属大区",
    worker: "清运者",
    inTouchMethods: "联系方式",
    inputTelNumber: "请输入电话号码",
    workplaceShouldNotEmpty: "工作区名称不能为空",
    staffNameShouldNotEmpty: "清运者名称不能为空",
    finishedEdit: "完成编辑",
    people: "(人)",
    tip: "提示",
    confirmDelete: "请确定是否执行”删除“操作",
    deleteForSure: "确认删除"
  },*/

  //login.jsx
  logIn: {
    accountNotExist: '用户名不存在',
    passwordError: '密码错误',
    unknownError: '未知错误',
    inputNumber: '请输入账号',
    account: '账户号',
    inputPassword: '请输入密码',
    passwordDemand: '请输入6位数或6位数以上的密码',
    password: '密码',
    rememberPassword: '记住密码',
    forgetPassword: '忘记密码？',
    loggedIn: '登录',
    getVerified: '获取验证码',
    notRepeatClick: '请勿重复点击',
    phoneNotBind: '手机号未绑定',
    wrongVerifiedCode: '验证码错误',
    inputPhoneNumber: '请输入手机号',
    validPhoneNumber: '请输入有效的手机号',
    phone: '手机号',
    inputVerifiedCode: '请输入验证码',
    inputCorrectCode: '请输入正确的验证码',
    verificationCode: '验证码',
    getVerifiedCode: '验证码已发送到你的手机，15分钟内有效',
    notReceivedCode: '没有收到验证码',
    notReceivedReason:
      '网络通讯异常可能会造成短信丢失，请重新获取或稍后重试。如果手机号已丢失或停用，请选择其他方式登录。',
    emailNotBind: '邮箱未绑定',
    inputEmailAccount: '请输入邮箱号',
    inputValidEmail: '请输入有效的邮箱号',
    getEmailVerifiedCode: '验证码已发送到你的邮箱，15分钟内有效',
    emailAccount: '邮箱号',
    notReceivedReason2:
      '网络通讯异常可能会造成邮件丢失，请重新获取或稍后重试。',
    loggedInHI: '登录HI环卫',
    noAccount: '没有账号?',
    registerImmediately: '立即注册',
    otherWayLog: '其他方式登录',
    verifiedByPhone: '手机号登录',
    verifiedByEmail: '邮箱登录',
    verifiedByPassword: '账号密码登录',
  },

  //register.js
  register: {
    inconsistentPasswords: '两次输入密码不相同',
    accountDemand: {
      inputAccount: '账号重复',
      atLeastLength: '账号最少6位',
      formatSetting: '英文字母开头,6~18位(字母、数字、下划线)',
      accountSetting: '请设置账号',
    },
    passwordDemand: {
      inputPassword: '请输入密码',
      passwordLength: '请设置为6位数或6位数以上的密码',
      passwordSetting: '设置密码',
      confirmPassword: '请确认您的密码',
      inputAgain: '再次输入密码',
    },
    registerAcc: '注册',
    agree: '我已阅读并同意《蜂巢服务条款》',
    reminding: '蜂巢智慧提醒您：',
    success: '注册成功!',
    terms: '蜂巢服务条款',
    contract: {
      serviceContent:
        '特别提示：<br/>\n' +
        '                                    以下条款是您与东莞蜂巢智慧智能科技有限公司（以下简称“蜂巢智慧”）于东莞市松山湖管委会（以下简称“本协议签订地”）所订立的具备法律效力的协议。本协议确立您使用HI环卫软件系统时享有的权利以及相应的法律责任，HI环卫软件系统指由东莞蜂巢智慧智能科技有限公司开发并作为本协议项下的软件系统，包括且不限于电脑端网站、移动端应用软件及在第三方网络平台上的公众号和小程序。在本协议中，“您”指任何使用和访问本服务的个人。<br/>\n' +
        '                                    请您务必仔细阅读、充分理解本协议中各条款，包括免除或者限制蜂巢智慧责任的免责条款及对用户的权利限制条款，点击同意表明您已经阅读并接受这些条款。如果您不接受本协议的所有条款，请您停止注册、登录或使用本服务。您的注册、登录、使用等行为将视为您同意接受本协议的约束。<br/>\n' +
        '                                    蜂巢智慧可能会根据需要不时修订或更新本协议及其相关补充和附件等文件，修订或更新后的协议和文件一经公布，立刻取代原协议和文件，即自动生效。如果您不接受相关的修订或更新，请立即停止使用HI环卫服务或与蜂巢智慧联系；如您继续使用HI环卫服务，即表示您已接受修订或更新后的协议和文件。<br/>\n' +
        '\n' +
        '                                    1. 用户注册<br/>\n' +
        '                                    1.1 用户应当向蜂巢智慧购买相关服务，获得蜂巢智慧许可后，进行HI环卫的注册工作，否则蜂巢智慧无法为客户提供HI环卫的各类服务。<br/>\n' +
        '                                    1.2 用户确认：HI环卫的注册用户包括政府机构、事业单位、企业以及政府机构、事业单位和企业的工作人员。用户分为Ⅰ、Ⅱ、Ⅲ三级：Ⅰ级用户为政府机构、事业单位、企业，由蜂巢智慧进行账号分配；Ⅱ级用户为政府机构、事业单位和企业的管理人员，由管理人员隶属的单位进行账号分配；Ⅲ级用户为环卫工人，由环卫工人的上级进行账号分配。<br/>\n' +
        '                                    1.3 注册方式：各级用户通过手机号进行绑定注册。Ⅱ、Ⅲ级用户在注册前，应当获得上级用户发送的邀请链接，点击邀请链接进行注册。Ⅰ级用户账号由蜂巢智慧进行分配，分配后直接进行登录。<br/>\n' +
        '                                    1.4 账号管理：用户注册成功后，每个用户获得专属账号，禁止赠予、借用、租用、转让或售卖。用户承担其账号与密码的保管责任，除平台方（如微信）或蜂巢智慧的过错外，用户就其账号及密码项下一切活动负全部责任。<br/>\n' +
        '\n' +
        '                                    2. 服务范围与使用规范<br/>\n' +
        '                                    2.1 Ⅰ级用户可以在电脑端查看其管辖区域内所有果皮箱、垃圾桶的溢满状况，分配管理所属工作人员的Ⅱ、Ⅲ级用户账号和果皮箱、垃圾桶，查看管辖区域内工作人员数据与果皮箱、垃圾桶数据；Ⅱ级用户可以在电脑端查看其管辖区域内所有果皮箱、垃圾桶的溢满状况，分配管理所属工作人员的Ⅲ级用户账号和果皮箱、垃圾桶，查看管辖区域内工作人员数据与果皮箱、垃圾桶数据；Ⅰ、Ⅱ、Ⅲ三级用户均可以在移动端及小程序查看其管辖区域内所有果皮箱、垃圾桶的溢满状况与最优路径。<br/>\n' +
        '                                    2.2 用户在使用HI环卫服务过程中，应当遵循以下规则：<br/>\n' +
        '                                    1）遵守中华人民共和国法律法规和政府规定；<br/>\n' +
        '                                    2）不得利用HI环卫软件系统进行任何可能对互联网造成不利影响的行为；<br/>\n' +
        '                                    3）不得侵犯任何第三方的专利权、著作权、商标权、名誉权、隐私权、个人信息或其他任何合法权益。<br/>\n' +
        '                                    2.3 蜂巢智慧有权在HI环卫系统上进行各类推广以及广告投放业务。<br/>\n' +
        '\n' +
        '                                    3. 传感器的安装与管理<br/>\n' +
        '                                    3.1 蜂巢智慧拥有品牌标记为“HI-Tech”的传感器的专利所有权，负责传感器的安装与维护。在传感器安装交付给客户前，传感器的所有权归属于蜂巢智慧；交付后，传感器的所有权归属于客户单位。<br/>\n' +
        '                                    3.2 未经蜂巢智慧同意，任何人不得破坏或移除所有权归属蜂巢智慧的传感器，蜂巢智慧有权向其索赔；如破坏或移除所有权归属他人的已经安装的传感器，蜂巢智慧亦有权代所有者向其索赔。<br/>\n' +
        '                                    3.3 任何人不得在传感器上张贴广告、涂抹，不得对传感器泼水、加热。<br/>\n' +
        '\n' +
        '                                    4. 知识产权声明<br/>\n' +
        '                                    4.1 HI环卫的一切著作权、商标权、专利权、商业秘密、数据等知识产权，以及相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。除涉及第三方授权的软件或技术外，蜂巢智慧享有HI环卫及其中所有内容的知识产权。<br/>\n' +
        '                                    4.2 用户不得对软件或者软件运行过程中释放到任何计算机终端内存中的数据及软件运行过程中，客户端与服务器端的交互数据进行下载、复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于插件、外挂或非经授权的第三方工具/服务。<br/>\n' +
        '\n' +
        '                                    5. 用户数据及隐私政策<br/>\n' +
        '                                    5.1 用户向蜂巢智慧提供的所有注册资料应当是真实、完整、准确、合法、有效的。如果用户提供的注册资料有所变更，用户应当及时更新，蜂巢智慧将依法对用户信息进行检查核实，用户应当配合提供最及时、真实、完整的信息。<br/>\n' +
        '                                    5.2 蜂巢智慧依法保护用户隐私，保证不对外公开或向第三方提供单个用户的注册资料及用户在使用服务时存储在HI环卫服务系统中受法律保护的隐私信息，以下情况除外：<br/>\n' +
        '                                    1）事先获得用户的明确同意；<br/>\n' +
        '                                    2）根据有关的法律法规要求；<br/>\n' +
        '                                    3）按照相关政府主管部门的要求；<br/>\n' +
        '                                    4）根据法院的生效判决、裁定或命令；<br/>\n' +
        '                                    5）为维护蜂巢智慧的合法权益或社会公共利益而在相关行政程序或司法程序中向政府主管部门或法院提供。<br/>\n' +
        '\n' +
        '                                    6. 免责声明<br/>\n' +
        '                                    6.1 蜂巢智慧对服务不作任何类型的担保，包括但不限于服务的及时性、安全性、准确性，对在任何情况下由可归于用户自身的原因导致的直接、间接、偶然、特殊及后续的损害及风险，蜂巢智慧不承担责任。<br/>\n' +
        '                                    6.2 对于不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何网络、技术、通信线路等原因造成的服务中断或不能满足用户需求的风险，用户理解并同意，蜂巢智慧对该等风险没有过错，蜂巢智慧不对此承担责任。<br/>\n' +
        '                                    6.3 用户充分理解并认可本协议各项约定，并同意蜂巢智慧免于承担因用户违反约定而产生的活与之有关的任何索赔、处罚、责任、费用或损失（包括但不限于第三方索赔），除非本协议另有约定或有证据证明蜂巢智慧对此具有重大过错。<br/>\n' +
        '\n' +
        '                                    7. 违约责任<br/>\n' +
        '                                    7.1 如因蜂巢智慧违反有关法律法规或本协议项下的任何条款，而给用户造成实际损失，蜂巢智慧同意承担由此造成的违约责任。<br/>\n' +
        '                                    7.2 用户同意保障和维护蜂巢智慧及其他用户的合法权益，如因用户违反有关法律法规或本协议项下的任何条款，而给蜂巢智慧或任何第三方造成损失，用户同意承担由此造成的违约责任，包括但不限于赔偿蜂巢智慧并使蜂巢智慧免于因此遭受所有直接和间接损失（包括任何直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等）。<br/>\n' +
        '\n' +
        '                                    8. 协议变更及终止<br/>\n' +
        '                                    8.1 鉴于互联网服务市场及相关领域的快速发展及变化，用户理解并同意，蜂巢智慧有权随时修改本协议的任何条款，一旦本协议的内容发生变动，蜂巢智慧会直接在HI环卫软件系统上公布修改后的协议内容（形式包括但不限于更新版本的协议、补充协议、协议新增附件等）。该公布行为视为蜂巢智慧已经通知用户修改内容，同时蜂巢智慧也可以通过其他适当方式向用户提示修改内容。<br/>\n' +
        '                                    8.2 用户不得单方终止本协议，如需终止本协议，应当联系蜂巢智慧进行友好的协商进行终止。<br/>\n' +
        '                                    8.3 蜂巢智慧在出现以下任何情况是，蜂巢智慧有权单方终止本协议：<br/>\n' +
        '                                    1）用户严重违反本协议约定，或多次违反本协议约定；<br/>\n' +
        '                                    2）用户行为存在异常，我们合理怀疑用户可能存在违法或违反本协议约定的行为，如果不终止本协议可能对蜂巢智慧、其他用户、公共秩序或公共利益造成不利影响；<br/>\n' +
        '                                    3）用户存在盗用他人账号、发布违禁信息、骗取他人财物、采取不正当手段牟利等行为；<br/>\n' +
        '                                    4）其他应当终止本协议的情况。<br/>\n' +
        '                                    8.4 本协议终止后，除法律另有明确规定外，蜂巢智慧无义务向用户或任何指定的第三方披露该用户账号中的任何信息。本协议终止后，蜂巢智慧仍享有以下权利：<br/>\n' +
        '                                    1）继续保存留存于HI环卫软件系统中的各类信息；<br/>\n' +
        '                                    2）对于用户过往的违约行为，我们仍可依据本协议追究其违约责任。<br/>\n' +
        '\n' +
        '                                    9. 适用法律与争议解决<br/>\n' +
        '                                    9.1 本协议的订立、履行和解释及与之相关的争议的解决均应适用中华人民共和国法律。<br/>\n' +
        '                                    9.2 如您与蜂巢智慧就本协议及其所有补充和附件的签署、内容、解释或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，对于因本协议及其所有补充和附件而产生的或与之有关的一切争议，您同意将其提交本协议签订地有管辖权的人民法院管辖。<br/>\n' +
        '\n' +
        '                                    10. 其他规定<br/>\n' +
        '                                    10.1 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，不影响本协议其他条款的效力。在此情形下，各方应当在合法范围内协商确定新的条款，以保证最大限度地实现原有条款的意图。<br/>\n' +
        '                                    10.2 本协议中的标题为方便理解而设，在解释本协议时不受该标题的限制。<br/>\n' +
        '                                    10.3 任何一方当事人放弃或延迟行使其在本协议项下的全部或部分权利的，不应视为其放弃本协议项下的任何其他权利或与此类似的一切权利。<br/>',
    },
    aAccount: '注册账号',
    haveAcc: '已有账号？',
    goLogin: '去登录',
  },

  //welcomeStore.js
  verifiedInfo: {
    getCode: '获取验证码',
  },

  //home.js
  //退出弹窗
  exitModal: {
    tip: '注意',
    confirm: '请确定是否退出当前账号',
    sure: '确定',
    cancel: '取消',
  },

  //distributeCans.js
  //分配箱子
  allocateCans: {
    manager: '负责人',
    area: '负责区域',
    canCount: '负责箱体数',
    unset: '未设置',
    edit: '点击编辑',
    inputWorkspace: '请输入工作区域',
    unit: '个',
    willAllocate: '待分配箱体',
    inChargingCans: '负责中箱体',
    search: '搜索',
    searchByID: '输入名称或ID查找',
    total: '共',
    equipment: '个设备',
    distribute: '分配',
    remove: '移出',
    got: '我知道了',
    gotDetail: '勾选垃圾桶后，即可开始分配垃圾桶。',
    toolbar: {
      home: '首页',
      staffManagement: '人员管理',
      createATeam: '创建团队',
      data: '数据',
      equipmentManage: '设备管理',
      accountManage: '账户管理',
      help: '帮助中心',
      myAcc: '我的账户',
      unfoldTab: '展开面板',
    },
    all:'全选',
  },
  //thermodynamic.js
  thermodynamic: {
    tips: '无数据！',
  },
  //DataDetail.js
  dataInfo: {
    unit: 'kg',
    detail: '数据明细',
    selectArea: '全部',
    import: '导出',
    time: '时间',
    area: '区域',
    total: '共',
    count: '个区域',
    prevPage: '上一页',
    nextPage: '下一页',
    page: '页',
    daily: '日报表',
    month: '月报表',
    exportData: '导出数据记录',
    rangeOfArea: '区域范围',
    chooseArea: '选择区域范围',
    rangeOfTime: '时间范围',
    sure: '确定',
    cancel: '取消',
    remind: '蜂巢智慧提醒您！',
    load: '下载',
    exportTipsTxt: '文件创建成功，您可以点击下载按钮来下载文件。',
    TipsPermissionErr: '权限错误',
    TipsBuildFail: '文件创建失败',
  },

  //Analysis.js
  dataAnalysis: {
    stability: '平稳',
    weightUnit: 't',
    collect: '收集量',
    deviceUnit: '个',
    isRunning: '设备正在运行',
    save: {
      water: '节约水',
      electricity: '节约电',
    },
    reduce: {
      burnAmount: '减少垃圾焚烧量',
      buryAmount: '减少垃圾填埋量',
    },
    controlArea: '管理区域',
    exportReduceData: '导出减量数据',
    operatePerson: '管理人员',
    operateArea: '区域管理',
    chooseArea: '全部',
    none: '无',
    cleaning: '清运',
    count: '次',
    prevPage: '上一页',
    nextPage: '下一页',
    accumulate: '累计回收废品',
    garbage:"累计回收垃圾",
    weightUnit2: 'kt',
    weightUnit3: 'mw·h',
    estimateSaving: '每年预计节约',
    estimateReducing: '每年预计减少',
    lastSevenDaysResource: '近7天节约资源量',
    lastSevenDaysTrash: '近7天减少垃圾处理量',
    personOperate: '人员管理',
    cleanTeam: '清运员工团队',
    cleanState: '人正在清运中...',
    analysisPlatform: '大数据分析平台',
    totalOperateState: '整体运行状态',
    middle: '良好',
    score: '87分',
    toolbar: {
      home: '首页',
      statistic: '数据统计',
      area: '区域管理',
      equipment: '设备管理',
      account: '我的账户',
      exit: '退出账户',
      fullScreen: '全屏显示',
      exitFullScreen: '退出',
    },
  },

  //Equipment.js
  deviceError: {
    number: 'No.',
    haveResolved: '已解决',
    haveNotResolved: '未解决',
    reason: {
      contactFailure: '无法交流',
      communicateError: '通信困难',
      measureDifficulty: '测距困难',
      measureIncorrect: '测不准',
      restart: '设备重新启动',
      deviceMiss: '丢失',
      other: '其他原因',
    },
    noErrorDevice: '此用户无故障设备',
    tip: '注意',
    sure: '确定',
    cancel: '取消',
    deleteAllRecord: '请确定是否将此故障设备的所有错误记录删除',
    confirmDelete: '您确认执行“解决”操作吗？',
    deviceProblem: {
      deviceFaulty: '故障设备',
      totalDeviceFaulty: '故障设备总计',
      cannotCommunicate: '无法交流设备',
      hardToCommunicate: '通信困难',
      hardToMeasure: '测距困难',
      incorrectMeasure: '测不准',
      otherErrorDevice: '其他故障设备',
      haveResolvedDevice: '已为您解决设备',
      deviceUnit: '个',
      name: '设备名称',
      number: '设备编号',
      type: '错误类型',
      status: '状态',
      total: '共',
      records: '条记录',
    },
    page: {
      prevPage: '上一页',
      nextPage: '下一页',
      total: '共',
      pages: '页',
      number: 'NO.',
    },
    records: {
      deleteAll: '删除全部记录',
      total: '共',
      recording: '条记录',
      prev: '上一页',
      next: '下一页',
    },
    allPlace: '全部',
    beilin: '碑林',
    expireDate: '到期时间',
    allChecked: '全选',
    detail: {
      name: '设备名称',
      number: '设备编号',
      area: '所属辖区',
      time: '到期时间',
      status: '状态',
    },
    item: {
      area:
        '长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园',
      deviceNumber: 'NO.324434344444',
      region: '陕西省西安市',
      date: '2019/06/01',
      expired: '已到期',
      totalDevice: '共 9 个设备',
      prevPage: '上一页',
      pageNumber: '1',
      nextPage: '下一页',
      charge: '去续费',
    },
  },

  //account.js
  myAccount: {
    account: '我的账户',
    accountPartOne: {
      detail: '团队信息',
      superAdmin: '超级管理员',
      commonAdmin: '管理员',
      accNumber: '账号',
      tel: '联系电话',
      email: '邮箱',
      address: '联系地址',
      unset: '未设置',
      detailInfo: {
        cleanUnit: '189个',
        cleanerNumber: '清运人员',
        carUnit: '189个',
        carNumber: '清运车辆',
      },
      edit: '编辑',
      view: '查看',
    },
    accountPartTwo: {
      myDevice: '我的设备',
      deviceNumber: '<span>--</span>个',
      // deviceInfo: '在运行--个，待续费--个，待分配--个',
      deviceInfo: '在运行--个，待分配--个',
      aboutDevice: '<其中在运行1036个，待续费3个，待分配15个>',
      orderNewDevice: '订购新设备',
      rechargeNewDevice: '充值现有设备',
      orderHistory: '历史订单',
      renewal: '设备续费',
    },
    accountPartThree: {
      myBalance: '我的余额',
      balanceDetail: '￥',
      charge: '充值',
      chargeHistory: '充值历史',
      todo: '待办事项',
      develop: '开发中',
      you: '您有',
      renew: '个设备急需续费。',
      toRenew: '去续费 >>',
      Allocate: '个设备处于未分配状态，快去分配吧。',
      toAllocate: '去管理人员分配 >>',
      improved: '您的账户资料有待完整哦~',
      toImproved: '去编辑 >>',
      know: '我知道了',
      empty: '暂无待办事项~',
    },
    accountPartFour: {
      securitySet: '安全设置',
      login: '登录密码',
      passwordSuggest: '您可以在此修改密码。',
      haveSet: '已设置',
      modify: '修改',
      bindPhone: '手机绑定',
      unset: '未设置',
      unsetDetail: '你还没有绑定手机',
      haveBind: '您已经绑定了手机',
      useYourPhone: '（您的手机可以直接用于登录、找回密码等)',
      unbind: '解绑成功',
      bind: '绑定',
      toUnbind: '解绑',
      logout: '退出账号',
      // logoutInfo:
      //   '如果您需要切换账号或其他退出需求，可以将其退出。退出后不影响再次进入。'
    },
    bookNewDevice: {
      orderNewDevice: '订购新设备',
      commonSensor: '通用型HIOS传感器',
      newGeneration: '新一代',
      model: '型号',
      storage: '存储',
      scene: '场景',
      installationType: '安装类型',
      format: '规格',
      quantity: '数量(个)',
      power: '供电方式',
      transform: '通信模式',
      distance: '测距距离',
      integrated: '集成款',
      help: '帮助',
      helpText:
        '多探头集成款包含多个探头，可用于集成到包含多个内容的收集容器中',
      position: '定位',
      duration: '时长',
      order: '结算',
      cancel: '取消',
      free: '省',
      yuan: '元',
      multiple: '探头集成款',
      month: '个月',
    },
    aboutBind: {
      successBind: '绑定成功',
      wrongPhoneNumberFormat: '手机号格式不正确',
      fillNumber: '请填写完整的手机号',
      wrongFormatNumber: '手机号格式不正确',
      numberHaveBound: '手机号已经绑定',
      wrongVerifiedCode: '验证码错误',
      sendCode: '发送验证码',
      modifyPhone: '修改绑定手机',
      rebind: '新绑定手机',
      verifiedCode: '手机验证码',
      inputPhoneNumber: '请输需要绑定的手机号',
      inputCode: '请填写6位数字验证码',
      sure: '确定',
      cancel: '取消',
      inputRightPassword: '请输入正确的密码',
      passRules: '6~18位(字母、数字、常用字符、字母区分大小写)',
      inconsistentPasswords: '两次输入密码不相同',
      originalFalse: '原密码错误',
      tryTwice: '请重新登录',
      demands: '密码应该在6~20位之间',
      modify: '修改登录密码',
      currPassword: '当前密码',
      inputCurr: '请输入当前密码',
      newPassword: '新密码',
      inputNewSet: '请输需要设置的新密码',
      confirm: '确认密码',
      inputAgain: '请再次输入新的密码',
      edit: '编辑',
      identify: '账号身份',
      superAdmin: '超级管理员',
      admin: '管理员',
      completeness: '完整度 60%',
      companyName: '公司名称',
      operator: '运营人',
      inputOperatorName: '请输入运营人名称',
      tel: '联系电话',
      inputTel: '请输入联系电话',
      email: '邮箱',
      inputEmail: '请输入邮箱',
      address: '联系地址',
      inputWorkspace: '请输入工作区名称',
      cleanerNumber: '清运人员数量',
      carsNumber: '清运车辆数量',
      finishedEdit: '完成编辑',
    },
    show: {
      tab: '显示',
    },
    editUser: {
      title: '编辑',
      userGroup: '账户身份',
      integrity: '完整度',
      errorCompany: '请输入正确的公司名(不少于6位)',
      errorEmail: '请输入正确的邮箱',
      errorNumber: '请输入正确的数字',
      errorPhone: '请输入正确的电话号码',
      staff: '人',
      car: '辆',
    },
    orderNew: {
      title: '订购新设备',
    },
  },
  //服务账户国际化
  serviceAccount: {
    serviceAccount: '服务账户',
    accountManagement: '用户管理',
    add: '添加',
    export: '导出',
    regionManagement: '区域管理',
    superior: '管辖归属',
    confirm: '确认',
    cancel: '取消',
    regionalLevel: '区域级别：',
    areaName: '区域名称：',
    editAccount: '编辑账户',
    automaticGeneration:'自动生成',
    userName: '用户名',
    accountPassword:'账户密码',
    regionName: '所属区域',
    permissionSetting: '权限设置',
    initialPassword:'初始密码',
    permission:'权限',
    edit:'编辑',
    total:'共 ',
    users:' 个用户',
    all:'全部',
    readOnly:'只读',
    confirmExportAll:'确认导出当前列表所有账户',
    exportAccount:'导出账户',
    sureToDelete:'确定删除',
    NoteForDelete:'注:删除区域及所属账户',
    EmptyNameWarning:'区域名称不能为空',
    province:'省',
    city:'市',
    region:'区',
    street:'街道',
    community:'社区',
    enterTheInformation:'请输入符合规则的信息',
    addAccount:'新建账户',
    tips:'提示',
    deleteSuccess:'刪除成功',
    deleteFailByReason:'有下属行政区或设备存在，无法删除',
    CompanyUnnamed:'公司未命名',
    pleaseSelect:'请选择',

  
  },
  //TestTop.js
  mapDetail: {
    inputID: '请输入ID',
    search: '搜索',
    refresh: '刷新',
  },
  //createArea.js
  areaPageDetail: {
    //创建大区表单
    districtCreate: {
      account: {
        duplicateAcc: '账号重复',
        differentTwice: '两次输入的密码不同!',
        districtAcc: '大区账号',
        accRules: '英文字母开头,6~18位(字母、数字、下划线)',
        inputAcc: '请输入账号!',
        placeholder: '请输入账号',
      },
      password: {
        pass: '密码',
        passRules: '6~18位(字母、数字、常用字符、字母区分大小写)',
        inputPass: '请输入密码',
        confirm: '确认密码',
        inputPass2: '请输入密码！',
        inputTwice: '请再次输入密码',
      },
      districtName: {
        name: '大区名称',
        inputName: '请输入大区名称',
        inputName2: '请输入大区名称！',
        rules: '(支持中文、英文、数字、下划线)',
      },
      admin: {
        name: '管理员姓名',
        inputName: '请输入管理员名称',
        inputName2: '请输入管理员名称！',
        rules: '(支持中文、英文、数字、下划线)',
      },
      staff: {
        number: '员工数量（单位:人）',
        wrongFormat: '格式不正确!',
        unit: '(人)',
        inputNumber: '请输入员工数量',
      },
      vehicle: {
        number: '车辆数量（单位:车）',
        wrongFormat: '格式不正确!',
        unit: '(车)',
        inputNumber: '请输入车辆数量',
      },
      isCreate: '创建',
      isCancel: '取消',
      establish: '创建',
      establishDistrict: '创建大区',
      completeness: '完整度',
    },
    //创建下属工作区表单
    subWorkAreaCreate: {
      duplicate: '账号重复',
      Inconsistent: '两次输入的密码不同！',
      workplace: {
        account: '工作区账号',
        rules: '英文字母开头，6~18位(字母、数字、下划线)',
        inputAccount: '请输入账号',
        inputAccount2: '请输入账号！',
      },
      password: {
        pass: '密码',
        rules: '6~18位(字母、数字、常用字符、字母区分大小写)',
        inputPass: '请输入密码',
        confirmPass: '确认密码',
        inputAgain: '请再次输入密码',
      },
      workspace: {
        name: '工作区名称',
        inputName: '请输入工作区名称',
        inputName2: '请输入工作区名称！',
        rules: '(支持中文、英文、数字、下划线)',
      },
      cleanerName: {
        name: '清运者名称',
        inputName: '请输入清运者员名称',
        inputName2: '请输入清运者员名称！',
        rules: '(支持中文、英文、数字、下划线)',
      },
      filledWeight: {
        vehicleWeight: '满车重量（单位:千克）',
        wrongFormat: '格式不正确!',
        inputWeight: '请输入满车重量',
      },
      isCreate: '创建',
      isCancel: '取消',
      establish: '创建',
      establishSub: '创建下属工作区账户',
      completeness: '完整度',
    },

    //编辑大区表单
    editDistrict: {
      districtInfo: {
        name: '大区名称',
        rule1: '大区名称不能为空!',
        rule2: '(支持中文、英文、数字、下划线)',
        inputName: '请输入大区名称',
      },
      admin: {
        manager: '管理员',
        rule1: '管理员名称不能为空!',
        rule2: '(支持中文、英文、数字、下划线)',
        inputName: '请输入管理员名称',
      },
      contact: {
        contactInfo: '联系方式',
        rule: '请输入正确的电话号码!',
        inputTel: '请输入联系电话',
      },
      staff: {
        number: '员工数量（单位:人）',
        error: '格式不正确!',
        inputNumber: '请输入员工数量',
        unit: '(人)',
      },
      vehicle: {
        number: '车辆数量（单位:辆）',
        error: '格式不正确!',
        unit: '(车)',
        inputNumber: '请输入车辆数量',
      },
      finished: '完成编辑',
      cancel: '取消',
      edit: '编辑',
      districtName: '大区账号',
      completeness: '完整度',
    },

    //编辑工作区表单
    editWorkspace: {
      districtInfo: {
        name: '工作区名称',
        error: '工作名称不能为空!',
        rule: '(支持中文、英文、数字、下划线)',
        inputWorkspace: '请输入工作区名称',
      },
      cleanerInfo: {
        cleaner: '清运者',
        error: '清运者名称不能为空!',
        rule: '(支持中文、英文、数字、下划线)',
        inputName: '请输入清运者名称',
      },
      contactInfo: {
        contactMethods: '联系方式',
        error: '请输入正确的电话号码!',
        inputTel: '请输入联系电话',
      },
      vehicle: {
        fullWeight: '满车重量（单位:千克）',
        error: '格式不正确!',
        inputFullWeight: '请输入满车重量',
      },
      finished: '完成编辑',
      cancel: '取消',
      modify: '编辑',
      workAreaAccount: '工作区账号',
      belong: '所属大区',
      completeness: '完整度',
    },
  },

  //MyAMap.js
  map: {
    refresh: '刷新',
  },

  //thermodynamic.js
  timeLine: {
    hour: '时',
  },

  //help.jsx
  //帮助模块
  helpCenter: {
    title: '常见问题',
    category: '目录',
    favor: '您需要哪方面的帮助？',
    search: '在这输入想找的对象...',
    helpDetail: {
      area: '区域管理',
      getAreaHelp: '获取区域划分、人员管理方面的帮助。',
      equipment: '设备管理',
      getEquipment: '获取故障设备、充值方面的帮助。',
      data: '数据统计',
      getData: '获取环卫员工数据、劳动量图、减量数据方面的帮助。',
      account: '账号管理',
      getAccount: '获取我的账户、历史订单、消息中心方面的帮助。',
      noKey: '没有搜索到您的关键字！',
    },
    suggest: {
      relative: '您可能觉得有用的相关问题',
      difference: '“大区”、“工作区”分别是什么？',
      workArea:
        '工作区是一个清运人员（司机）所负责的区域，并配备一个清运人员（司机）账号用于工作，而大区是几个工作区的整合，并配备一个管理员账号进行管理。',
      distribute: '如何分配箱子到各个区域？',
      install:
        '设备安装时，用哪个司机账号进行安装便会自动将该箱子分配到该司机名下，若后续还要进行调整，请在PC端人员管理界面，对需要调整的工作区进行“分配”操作。',
    },
    support: {
      download: '下载地址：',
      manual: {
        compose: 'Meet Hive产品介绍手册由七部分构成：',
        problem: '第一节 行业难题',
        introduce: '第二节 蜂巢简介',
        product: '第三节 产品介绍',
        case: '第四节 产品案例',
        install: '第五节 安装与培训',
        guarantee: '第六节 质量保证与保修',
        about: '第七节 关于蜂巢',
      },
    },
    contact: {
      humanService:
        '您如果需要人工服务，请致电我们的联系电话或者邮件至我们的官方邮箱，邮件请注明公司名。',
      tele: '联系电话：+86-15399420457/029-87977358',
      email: '邮箱：hive@hive-intel.com',
      address: '地址：东莞松山湖高新技术产业开发区国际机器人产业基地3楼304室',
      add2: '陕西省西安市莲湖区二环南路西段395号亚美伟博广场907室',
    },
    official: {
      officialPc: 'HI环卫电脑端网址',
      pcwebsite: 'http://pc.hive-intel.com',
      applet: 'HI环卫微信小程序',
      des: 'HI环卫',
      titleDes: 'HI环卫',
      appletDes: 'APP',
      installApplet: '设备安装APP',
      position: 'HI箱体定位工具',
      positionTool: 'HI箱体定位工具',
      serviceAccount: '微信服务号',
      hiClear: 'HI清运',
      serviceAcc: '服务号',
      officialAcc: '微信订阅号',
      brand: 'Meet Hive蜂巢智慧',
      brand2: 'Meet Hive蜂巢智慧',
      subscribe: '订阅号',
      officialWebsite: '蜂巢官网',
      webAddress: 'http://hive-intel.com',
    },
    countenance: '支持',
    content: '目录',
    whatYouNeed: '您需要哪方面的帮助？',
    inputToSearch: '在这输入想找的对象...',
    about: {
      downloadDocs: '文档下载',
      getFile: '获取安装指南、试用指南等文档的下载和浏览。',
      contact: 'HI环卫相关联系方式',
      getTouch: '获取HI环卫服务热线、邮箱等方面的帮助。',
      official: 'HI环卫官方平台',
      getOfficial: '获取HI箱体定位工具、服务号信息等方面的帮助。',
      contactUs: '联系我们',
      phone: '029-87977358',
      noKey: '没有搜索到您的关键字！',
    },
  },
  //区域动态
  sanitation: {
    title: '区域动态',
    des1: '目前有',
    des2: '个工作区',
    cleanerBtn: '管理路径',
    cleanerDetail: '详情',
  },
  //路径规划
  pathPlanning: {
    map: {
      start: '起点',
      end: '终点',
      setGarage: '选为车库',
      setWarehouse: '选为仓库',
      expectedRecyclable: '预计可回收',
      haveReceived: '已收',
      actually: '实际',
      history: '历史',
      Intelligence: '智能',
    },
    sure: '确定',
    cancel: '取消',
    dialogTitle: '设置智能规划参数',
    noPoint: '未设置车库仓库位置,在上方设置后方可看到详细路径。',
    pointBtn: '应用',
    createNewPath: '创建新路径',
    addressCanNotEmpty: '车库仓库需要一起设置，请填写完整!',
    garageTips: '请选择具体的地址！',
    startPoint: '起点',
    endPoint: '终点',
    garageLabel: '车库',
    carSpace: '回收车空间',
    carSpaceTips: '规划时回收车可能不是空载状态，因此需要设置此参数',
    minVolume: '回收箱最低货量',
    minVolumeTips: '低于此货量的回收箱不纳入智能规划中',
    garagePlaceholder: '请输入车库名称',
    warehouseTips: '请选择具体的地址！',
    warehouseLabel: '仓库',
    warehousePlaceholder: '请输入仓库名称',
    setPointSuccess: '设置成功!',
    setPointFail: '设置失败，请稍后再试!',
    clearRoute: '实际清运路线',
    clearDesKg: '千克',
    clearDesKil: '公里',
    clearDesHour: '小时',
    clearDesOne: '清运了',
    clearDesTwo: '行驶',
    clearThree: '耗时',
    clearDesFour: '路线效率',
    historyRouteShow: '显示到地图',
    historyRouteUnShow: '隐藏',
    historyRouteTitle: '历史智能规划路线',
    historyDesOne: '可清运',
    historyDesTwo: '将行驶',
    historyDesThree: '参数',
    historyFour: '以下不收',
    historyBuild: '创建于',
    historyCarSpace: '车子空间',
    historyMinVolume: '回收箱',
    planningTitle: '当前智能规划路线',
    noPlanningTips: '暂无智能规划路线',
    noPlanningTipsDes: '您可以在这为员工设置您想要的智能规划路线。',
    noPlanningBtn: '创建',
    pageTipsTitle: '提示',
    pageTipsContent:
      '请检查满车重量是否设置，若正确设置仍无法规划，请联系客服。',
  },
  //规格管理页面
  specification: {
    unassigned: '未分配',
    pageTitle: '规格管理',
    searchContent: '在这输入想找的对象...',
    selectAll: '全选',
    equipmentName: '设备名称',
    equipmentId: '设备编号',
    areaChoseAll: '全部',
    specChoseAll: '全部规格',
    operating: '操作',
    modifySpec: '更换规格',
    replace: '更换规格包',
    specPackage: '规格包',
    sonCanName: '箱体数量',
    labelSpec: '标签/规格',
    addPackage: '添加规格包',
    packageName: '规格包名称',
    household: '厨余垃圾',
    hazardous: '有害垃圾',
    residual: '其它垃圾',
    recyclable: '可回收垃圾',
    customize: '自定义',
    total: '共',
    records: '个设备',
    previous: '上一页',
    next: '下一页',
    pages: '页',
    batchEdit: '批量修改',
    modifySpecInBatch: '批量修改规格',
    selected: '已选',
    devices: '个箱体',
    specificationList: '规格列表',
    installHeight: '安装高度',
    fullDevicesHeight: '满箱高度',
    fullDevicesWeight: '满箱重量',
    meter: '米',
    kilogram: '千克',
    edit: '编辑',
    delete: '删除',
    add: '添加规格',
    addNewSpecification: '添加新规格',
    addTipsOne: '该值不应大于450厘米',
    addTipsTwo: '满箱高度不应大于安装高度',
    addTipsThree: '箱体规格名称重复，请重新填写提交。',
    addTipsFour: '箱体规格参数重复，请重新填写提交。',
    completion: '完整度',
    specificationName: '规格名称',
    inputTips: '点击设置',
    inputErrTips: '请填写完整',
    inputErrTipsTwo: '请填写数字',
    devicesType: '箱体类型',
    selectType: '请选择箱体类型!',
    clothingBox: '衣物箱',
    trashBox: '垃圾箱',
    transferBox: '中转箱',
    finishEdit: '完成编辑',
    finish: '完成添加',
    cancel: '取消',
    selectSpec: '选择规格',
    selectTips:
      '在此刻选择的是已创建的规格，如果有其他规格需求，可按照需求在此页面创建新的规格。',
    selectDes: '您可以自由选择已有的列表中的规格',
    installTips:
      '“安装高度“指的是设备所安装的位置到箱子底部的距离，正确填写才可以保证的设备的测量精度。',
    fullHeightTips:
      '“满箱高度“指的是贵公司所认为的箱体爆满报警线的位置，正确填写才可以保证设备的测量精度。',
    fullWeightTips:
      '“满箱重量“指的是贵公司箱体爆满时可收集出的货物的重量，正确填写才可以保证年、月、日等报表上的数据准确。',
    tips: '提示',
    yes: '是',
    no: '否',
    confirm: '确定',
    deleteContent: '请确定是否执行“删除”操作',
    deleteErrTips: '此规格正在使用，无法删除。',
    editTips:
      '有箱体正在使用该规格，是否将变化应用到这些箱体。点击否将新添加规格。',
    error: {
      authority: '您无权限执行此操作。',
      nameRepeat: '箱体规格名称重复，请重新填写提交。',
      parameterRepeat: '箱体规格参数重复，请重新填写提交。',
      dragNum: '请选择和该设备相匹配的规格包',
      isUsing: '此规格包有箱体正在使用，禁止修改，请新建规格包',
    },
    replaceSpecPackage: '更换规格包',
    selectSpecPackage: '选择规格包',
    confirmToReplace: '确定更换',
    spePackageSameName: '规格包名称重复',
    specPackSameParams: '存在相同参数的规格包',
  },
  power: {
    pageTitle: '电量管理',
    searchContent: '请输入名称或编号查找',
    tableTitle: {
      selectAll: '全选',
      deviceName: '设备名称',
      deviceID: '设备编号',
      areaAll: '全部',
      power: '剩余电量',
      life: '预期寿命',
      month: '月',
      sensitive: '上报阈值',
      action: '操作',
      button: '修改阈值',
      total: '共',
      device: '个设备',
      multiChange: '批量修改',
      powerError: '电量异常',
      unassigned: '未分配',
      unnamed: '未命名',
    },
    tips: {
      title: '提示',
      lineOne: '修改阈值用于设备功耗与实时性的动态平衡。',
      lineTwo: '降低阈值将提高设备数据上报的实时性，但也会增加设备的功耗。',
      lineThree: '提高阈值将减少设备的功耗同时降低设备数据上报的实时性。',
      lineFour: '阈值建议取值范围：5%~25%。',
    },
    change: {
      title: '修改阈值',
      original: '原阈值',
      new: '新阈值',
      cancel: '取消',
      confirm: '完成修改',
      select: '已选中',
      device: '个设备',
    },
  },
  recharge: {
    pageTitle: '设备续费',
    searchContent: '在这里输入想找的对象',
    automaticRenewal: '自动续费',
    turnOn: '开启',
    shutDown: '关闭',
    atWork: '工作中',
    expired: '已到期',
    dueSoon: '即将到期',
    toSettle: '去续费',
    noPermission: '权限不足，请联系超级管理员进行操作',
  },
  orderHistory: {
    confirm: '确定',
    reset: '重置',
    emptyText: '暂无数据',
    title: '历史订单',
    event: '事件',
    number: '数量',
    transactionHour: '交易时间',
    amount: '金额',
    orderNum: '订单编号',
    equipmentOrder: '设备订购',
    equipmentRenewal: '设备续费',
    accountRecharge: '账户充值',
    other: '其他',
    orderState: {
      done: '已完成',
      close: '已关闭',
      toBePaid: '待支付',
    },
    alipay: '支付宝',
    weChatPay: '微信支付',
    accountBalance: '账户余额',
    toPay: '去支付',
  },
  orderDetail: {
    year: '年',
    month: '个月',
    title: '历史订单',
    orderDetail: '订单详情',
    detail: '详情',
    orderNum: '订单号',
    expirationTime: '支付过期时间',
    operating: '操作',
    pay: '支付',
    cancel: '取消',
    state: '状态',
    unpaid: '未支付',
    orderTime: '下单时间',
    originalPrice: '原价',
    yuan: '元',
    amountToPaid: '待支付金额',
    orderPrice: '订单金额',
    payPrice: '支付金额',
    rechargeToAccount: '充值已到账，去',
    account: '账户',
    view: '查看',
    order: '订单明细',
    product: '产品/实例id',
    paymentMethod: '支付方式',
    duration: '时长',
    expireDate: '购买后到期时间',
    price: '价格',
    model: '型号',
    scenes: '场景',
    poweredBy: '供电',
    communicationMode: '通信模式',
    rangingDistance: '测距距离',
    integrationType: '集成类型',
    none: '无',
    integrationTxt: '探头集成款',
    typeOfInstallation: '安装类型',
    position: '定位',
    discount: '已优惠',
    saving: '已省',
  },
  payProcess: {
    pay: '支付',
    minute: '分',
    second: '秒',
    payOrder: '订单支付',
    accountNumber: '账号',
    transactionNumber: '交易号',
    commodityOrder: '商品订单',
    originalOrder: '原始订单',
    paymentAmount: '支付金额',
    orderDetails: '订单详情',
    orderTime: '下单时间',
    payTheRemainingTime: '支付剩余时间',
    payResult: '支付结果',
    paymentSuccessful: '支付成功',
    paymentFailed: '支付失败',
    close: '关闭',
    weChatPay: '打开手机微信，扫一扫完成支付',
    alipay: '打开手机支付宝，扫一扫完成支付',
  },
  payment: {
    confirm: {
      detail: '产品详情',
      count: '总数量',
      duration: '使用时长',
      durationHelp: '设备激活后开始计算使用时长',
      price: '价格',
      autoCharge: '自动续费',
      info: '配置基本信息',
      agree: '我已阅读并同意',
      licese: '《蜂巢智慧衣物回收产品服务协议》',
      totalFee: '总计费用',
      confirm: '确认下单',
      confirmPay: '确认支付',
      year: '年',
      errorTips: '请勾选产品服务协议后购买！',
      name: '名称',
      partition: '分区',
      principal: '负责人',
    },
    balance: {
      chargeAccount: '充值帐户',
      remain: '账户余额',
      charge: '充值',
      chargePrice: '充值金额',
      chargeTips: '充值说明',
      chargeTipsFir: '充值不可退款，请谨慎操作',
      chargeTipsSec: '充值金额消费后才可开具发票',
    },
    charge: {
      availTime: '到期时间',
      chargeTime: '续费时长',
      newAvailTime: '续费后到期时间',
      discountTip: '购买半年时长，包月预付优惠价基础，再享8.3折优惠',
      action: '详情',
      viewDevice: '查看设备',
    },
    begin: {
      target: '交易对象',
      company: '蜂巢智慧智能科技有限公司',
      order: '订单号',
      withBalance: '当前余额',
      availbleBalance: '可用余额',
      yuan: '元',
      thirdPay: '使用其他方式支付',
      thirdPayHelp:
        '在线支付仅支持以下三种支付渠道，点击“立即支付”后您可在新开页面选择其中任意一种渠道进行支付',
      thirdLimit: '交易限额说明',
      thirdLimitHelpFir: '1.蜂巢智慧平台的交易限额：0.01-9999999元;',
      thirdLimitHelpSec:
        '2.微信支付/支付宝支付/网银会依据银行要求进行交易额度的限制，以保证您的资金安全。不同支付平台、不同银行、不同卡类型对应限额额度不同，具体额度请以您实际支付中的提示为准；',
      thirdLimitHelpThi: '3.大额交易建议您可使用线下汇款充值。',
      totalFee: '订单金额',
      confirm: '立即支付',
      orderTips: '温馨提示：请在15分钟内完成订单支付，15分钟后订单将自动关闭',
      okText: '支付成功',
      cancelText: '支付失败，重试',
      wait: '等待支付',
      autoCancel: '秒后订单将自动关闭',
      newPage: '请在新页面中完成支付',
      reopen: '重新打开',
      loading: '正在更新订单状态',
    },
    result: {
      success: '支付成功',
      fail: '支付失败',
      successTo: '秒后进入订单详情页',
      failTo: '查看订单',
    },
    step: {
      confirm: '确认订单',
      begin: '支付',
      result: '支付结果',
      info: '基本信息',
    },
  },
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js